export const CONTENTS_REQUEST = "CONTENTS_REQUEST";
export const CONTENTS_REQUEST_SUCCEEDED = "CONTENTS_REQUEST_SUCCEEDED";
export const CONTENTS_REQUEST_FAILED = "CONTENTS_REQUEST_FAILED";

export const GET_USER_CONTENTS_REQUEST = "GET_USER_CONTENTS_REQUEST";
export const GET_USER_CONTENTS_REQUEST_SUCCEEDED = "GET_USER_CONTENTS_REQUEST_SUCCEEDED";
export const GET_USER_CONTENTS_REQUEST_FAILED = "GET_USER_CONTENTS_REQUEST_FAILED";
